/**
 * Product Gallery
 * Handles thumbnail click to swap the main image.
 */

document.addEventListener('DOMContentLoaded', () => {
  const galleries = document.querySelectorAll('.product-gallery');

  galleries.forEach((gallery) => {
    const mainImage = gallery.querySelector('.product-gallery__main-image');
    const thumbnails = gallery.querySelectorAll('.product-gallery__thumbnail');

    if (!mainImage || thumbnails.length === 0) return;

    thumbnails.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const thumbImg = thumb.querySelector('.product-gallery__thumbnail-image');
        if (!thumbImg) return;

        // Update main image src and srcset
        mainImage.src = thumbImg.dataset.fullSrc || thumbImg.src;
        mainImage.srcset = thumbImg.dataset.fullSrcset || '';
        mainImage.alt = thumbImg.alt;

        // Toggle active state
        thumbnails.forEach((t) => t.classList.remove('product-gallery__thumbnail--active'));
        thumb.classList.add('product-gallery__thumbnail--active');
      });
    });
  });
});
